export const ERROR_MESSAGES: Record<string, string> = {
  '404': 'Parece que la página que buscás no existe o fue removida',
}
